import React, {Component} from 'react';
import '../global';
import { connect } from 'react-redux';
import { getOrderHistory, getOrdersHistory } from '../actions';
import Loading from '../../components/loading-component';
class OrderHistory extends Component {
    constructor(props) {
        super(props);
        this.handleOlderOrdersClick = this.handleOlderOrdersClick.bind(this);
        this.state = {
            initialLoading: true,
            isFirstMount: true,
            tabType: 'protocol'
        };
    }


    componentWillUnmount() {
        this.removeOlderOrdersButtonListener();
    }

    addOlderOrdersButtonListener() {
        const olderOrdersButton = document.getElementsByClassName('btn-older-orders');
        Array.from(olderOrdersButton || []).map(button => {
            if (button && !button.hasOlderOrdersListener) {
                button.addEventListener('click', this.handleOlderOrdersClick);
                button.hasOlderOrdersListener = true;
            }
            return button;
        });

        const ordersCatTab = document.getElementsByClassName('orders-cat-tab');
        Array.from(ordersCatTab || []).map(tab => {
            if (tab && !tab.hasTabOrdersListener) {
                tab.addEventListener('click', this.handleTabOrdersClick.bind(this));
                tab.hasTabOrdersListener = true;
            }
            return tab;
        });
    }

    removeOlderOrdersButtonListener() {
        const olderOrdersButton = document.getElementsByClassName('btn-older-orders');

        Array.from(olderOrdersButton || []).map(button => {
            if (button && button.hasOlderOrdersListener) {
                button.removeEventListener('click', this.handleOlderOrdersClick);
                delete button.hasOlderOrdersListener;
            }
            return button;
        });
    }

    handleTabOrdersClick(event){
        const olderOrdersButton = event.currentTarget;
        const type = olderOrdersButton.getAttribute("tab-id");
        this.setState({ tabType: type });
    }

    handleOlderOrdersClick(event) {
        const olderOrdersButton = event.currentTarget;
        const type = olderOrdersButton.getAttribute("type-attr");

        if (olderOrdersButton) {
            olderOrdersButton.disabled = true;
            // Change the button text when disabled
            olderOrdersButton.innerHTML = '<img src="'+ISDA_Main.ajaxLoader+'" alt="Loading...">';
        }

        this.setState({ isButtonDisabled: true });
        this.props.getOrdersHistory(this.props.historyPagination[this.state.tabType], type, 100);
    }

    componentDidUpdate(prevProps) {
        this.addOlderOrdersButtonListener();
        if (prevProps.loading && !this.props.loading) {
            const olderOrdersButton = document.getElementById('btn-older-orders-' + this.state.tabType);
            if (olderOrdersButton) {
                olderOrdersButton.disabled = false;
                olderOrdersButton.textContent = 'Click Here to Show More Orders';
            }

            this.setState({ isButtonDisabled: false, initialLoading: false });
            this.appendAdherenceHistoryToTable();
            this.setState({ isFirstMount: false });
        }
    }

    appendAdherenceHistoryToTable() {
        const { historyPagination, history } = this.props;
        let tabType = this.state.tabType

        if (!tabType || !history || !history[tabType] || !history[tabType].current) return;

        if(historyPagination[tabType] > 1){
            if(history[tabType]['current'].length < 100){
                const olderOrdersButton = document.getElementById('btn-older-orders-' + tabType);
                olderOrdersButton.disabled = true;
                olderOrdersButton.style.color = 'grey';
            }
        }

        const table = document.getElementById(`table-${tabType}`);

        if (!table) return;

        const tbody = table.querySelector('tbody');

        if (!tbody) return;

        const items = this.state.isFirstMount
            ? history[tabType].all_items
            : history[tabType].current;

        if (!items || !items.length) return;

        items.forEach(item => {
            const row = document.createElement('tr');
            let codeRow = ''

            if(this.state.tabType === 'protocol'){
                codeRow = `<td>${item.imis_code}</td>`
            }

            row.innerHTML = `
            <td>
                #${item.order_number}<br/>
                ${item.order_date}<br/>
                <small>
                    <a href="/my-account/receipt/${item.order_number}" target="_blank">
                        View Receipt
                        <span class="sr-only">Will trigger a new tab or window to open.</span>
                    </a>
                </small>
            </td>
            ${codeRow}
            <td>
                <strong>${item.description}</strong><br/>
                <p>${item.adherence_info}</p>
                ${item.category === 'Event' && !item.imis_code.includes('SESS') ?
                `<br><small><b>Fee Type:</b> ${item.fee_type}</small>` : ''}
            </td>
            <td>${item.quantity}</td>
            <td>${item.price}</td>
            <td>${item.action_link}</td>
        `;
            tbody.appendChild(row);

            if (item.is_early_bird && item.is_regular_fee_type && !item.imis_code.includes('SESS')) {
                const earlyBirdRow = document.createElement('tr');
                earlyBirdRow.innerHTML = '<td>*EARLY BIRD PRICE*</td>';
                tbody.appendChild(earlyBirdRow);
            }

            if (item.category === 'Event' && !item.imis_code.includes('SESS') && item.hybrid_reg_type) {
                const regTypeRow = document.createElement('tr');
                regTypeRow.innerHTML = `<td colspan="${item.type === 'protocol' ? '6' : '5'}">
                <small><b>Registration Type:</b> ${item.hybrid_reg_type}</small>
            </td>`;
                tbody.appendChild(regTypeRow);
            }
        });
    }


	
    componentWillMount() {
        if (!this.props.orderHistory || Object.keys(this.props.orderHistory).length === 0) {
            this.props.getOrderHistory();
        }
    }

	render(){
        if (this.state.initialLoading && this.props.orderHistory.length === 0) {
            return <Loading width="100%" height="50px" amount={1} />;
        }
		return(
			<div dangerouslySetInnerHTML={{ __html: this.props.orderHistory.message || '' }} />
		)
	}
    
}


function mapStateToProps(state) {
    const orderHistory = state.orderHistory;
    const history = state.adherenceHistory;
    const loading = state.loading;

    return {
        orderHistory: orderHistory,
        loading: loading,
        history: history,
        historyPagination: state.adherenceHistoryPagination || {},
    };
}

export default connect(mapStateToProps, { getOrderHistory, getOrdersHistory})(OrderHistory);